<template>
  <div class="change-password">
    <div class="logo">
    </div>

    <div class="message-container" v-if="!responseReceived">
      <h2>Authenticating</h2>
      <div>
        Please wait...
      </div>
    </div>

    <div class="message-container" v-if="!showForm">
      <h2 class="white">Enter a new password</h2>

      <div class="message" v-bind:class="{error: validation.hasError('password')}">{{ validation.firstError('password') }}</div>
      <input type="password" v-bind:class="{errorInput: validation.hasError('password')}" v-model="password" placeholder="Password" />

      <div class="button" v-on:click="updatePassword">
        Update Password
      </div>
    </div>

    <div class="success-container" v-if="passwordReset">
      <h2>Password Updated</h2>
      <div v-on:click="login">
        Your password has been updated. Click here to login with your new password.
      </div>
    </div>

    <div class="error-message-container" v-if="error">
      <div>
        {{errorMessage}}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import SimpleVueValidation from 'simple-vue-validator'
import '../styles/base.css'

const Validator = SimpleVueValidation.Validator

export default {
  name: 'ResetPassword',

  computed: {
    responseReceived: function () {
      return this.error || this.authenticated
    },
    showForm: function () {
      return this.authenticated && this.passwordReset
    }
  },

  data () {
    return {
      authenticated: false,
      error: false,
      errorMessage: '',
      password: '',
      passwordReset: false,
      userId: ''
    }
  },

  mounted () {
    this.checkHash()
  },

  methods: {
    checkHash: function () {
      axios.get('/api/reset-password', {
        params: {
          hash: this.hash
        }
      })
        .then((response) => {
          this.authenticated = true
          this.userId = response.data.user_id
        })
        .catch((err) => {
          this.errorMessage = err
          this.error = true
        })
    },

    login: function () {
      this.$router.push('/login')
    },

    updatePassword: function () {
      this.$validate()
        .then((success) => {
          if (success) {
            let data = {
              password: this.password,
              user_id: this.userId
            }

            axios.put('/api/reset-password', data)
              .then((response) => {
                console.log('Password updated', response)
                this.passwordReset = true
                this.error = false
                this.errorMessage = ''
              }).catch(err => {
                console.log('Error while updating password: ', err)
                this.error = true
                this.errorMessage = 'Something went wrong while resetting your password.'
              })
          }
        })
    }
  },

  props: ['hash'],

  validators: {
    password: function (value) {
      return Validator.value(value).required().minLength(6)
    }
  }
}
</script>

<style scoped>
  .button {
    cursor: pointer;
    font-size: 1.2em;
    margin-top: 1.5em;
    padding: 1em;
    width: 400px;
  }

  .change-password {
    align-items: center;
    background: url("../assets/images/login-bg.gif");
    height: 100vh;
    margin: 0 auto;
    overflow: auto;
    position: relative;
    width: 100vw;
  }

  .error-message-container {
    color: var(--error);
    margin: 3em auto;
    position: relative;
    text-align: center;
    width: 400px;
  }

  .message-container {
    margin: 3em auto;
    position: relative;
    text-align: center;
    width: 400px;
  }

  h2 {
    margin: 0;
  }

  input {
    border: none;
    display: block;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 1.2em;
    margin-bottom: .5em;
    padding: 1em;
    width: 400px;
  }

  input:focus {
    outline: 5px solid var(--focus);
  }

  .message {
    height: 22px;
    margin-bottom: .5em;
    text-align: left;
  }

  .login-link {
    color: white;
    cursor: pointer;
    padding: 2em;
    text-align: center;
  }

  .login-link:hover {
    color: var(--primary);
  }

  .logo {
    border: 1px solid white;
    height: 100px;
    margin: 4em auto 4em auto;
    width: 200px;
  }

  .return-to-login {
    color: var(--primary);
    cursor: pointer;
    padding: 1em;
    text-align: center;
  }

  .return-to-login:hover {
    color: var(--primary-dark);
  }

  span {
    color: var(--primary);
  }

  .success-container {
    background: white;
    cursor: pointer;
    margin: 3em auto;
    padding: 1em;
    position: relative;
    text-align: center;
    width: 400px;
  }

  .white {
    color: white;
  }

  @media only screen and (max-width: 420px) {
    .button {
      width: 300px;
    }

    .message-container {
      width: 300px;
    }

    input[type=text], input[type=phone], input[type=email], input[type=password], textarea {
      width: 300px;
    }

    .logo {
      width: 300px;
    }
  }
</style>
